module.exports = __webpack_public_path__ + "img/EirCodeLogo-blue.png";